export class PermissionDto {
  id: number;
  title: string;
  rule: string;
  description: string;
  audience: string;
}

export const PERMISSION_AUDIENCE = {
  AUDIT: 'audit',
  ACCOUNTING: 'accounting',
  COMPANY: 'company',
  EVENT: 'event',
  TASKS: 'tasks',
  GEOGRAPHY: 'geo',
  INVOICE: 'invoice',
  LEGAL_ENTITY: 'legal-entity',
  MEDIA: 'media',
  PRICE: 'price',
  PURCHASES: 'purchases',
  REPORT: 'report',
  SALARY: 'salary',
  SALES_DEPARTMENTS: 'sales_departments',
  SETTING: 'setting',
  SUPPLIERS: 'suppliers',
  USER: 'user',
  USERS: 'users',
  TAGS: 'tag',
} as const;

export type Audience = (typeof PERMISSION_AUDIENCE)[keyof typeof PERMISSION_AUDIENCE];

export const PERMISSION_AUDIENCE_RU: Record<Audience, string> = {
  [PERMISSION_AUDIENCE.AUDIT]: 'Аудит',
  [PERMISSION_AUDIENCE.ACCOUNTING]: 'Бухгалтерия',
  [PERMISSION_AUDIENCE.COMPANY]: 'Компании',
  [PERMISSION_AUDIENCE.EVENT]: 'Дела',
  [PERMISSION_AUDIENCE.TASKS]: 'Задачи',
  [PERMISSION_AUDIENCE.GEOGRAPHY]: 'География',
  [PERMISSION_AUDIENCE.INVOICE]: 'Счета',
  [PERMISSION_AUDIENCE.LEGAL_ENTITY]: 'Формы собственности (Юр.лица)',
  [PERMISSION_AUDIENCE.MEDIA]: 'Медиа и СМИ',
  [PERMISSION_AUDIENCE.PRICE]: 'Прайсы',
  [PERMISSION_AUDIENCE.PURCHASES]: 'Заявки',
  [PERMISSION_AUDIENCE.REPORT]: 'Отчеты',
  [PERMISSION_AUDIENCE.SALARY]: 'Зарплата',
  [PERMISSION_AUDIENCE.SALES_DEPARTMENTS]: 'Отделы продаж',
  [PERMISSION_AUDIENCE.SETTING]: 'Настройки',
  [PERMISSION_AUDIENCE.TAGS]: 'Теги',
  [PERMISSION_AUDIENCE.SUPPLIERS]: 'Поставщики',
  [PERMISSION_AUDIENCE.USERS]: 'Пользователи',
  [PERMISSION_AUDIENCE.USER]: 'Пользователь (Общее)',
};
